import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { API_BASE } from './lib/api'

// Le backoffice (app.finance-for-you.com) appelle l'API (api.finance-for-you.com)
// en cross-sous-domaine : le cookie de session BetterAuth n'est envoyé QUE si
// credentials:'include' est posé. On force ce défaut sur toutes les requêtes vers
// l'API pour éviter les 401 sur les fetch qui l'auraient oublié.
const _originalFetch = window.fetch.bind(window)
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.href
        : input.url
  if (url && url.startsWith(API_BASE)) {
    init = { ...init, credentials: init?.credentials ?? 'include' }
  }
  return _originalFetch(input, init)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
